/**
 * Inventory Service API
 * This is the inventory-service API generated by springdocs - a library for OpenAPI 3 with spring boot.
 *
 * The version of the OpenAPI document: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProductDocumentDto } from './productDocumentDto';
import { ProductRatingDto } from './productRatingDto';
import { ProductHighlightDto } from './productHighlightDto';
import { ProductImageDto } from './productImageDto';
import { ProductDistributorDto } from './productDistributorDto';
import { ProductOverviewDto } from './productOverviewDto';
import { ProductSpecificationDto } from './productSpecificationDto';


export interface ProductDto { 
    id?: number;
    uid?: string;
    code?: string;
    name?: string;
    longName?: string;
    brand?: string;
    image?: string;
    price?: number;
    discount?: number;
    category?: string;
    subCategory?: string;
    inventory?: number;
    inventoryStatus?: string;
    qty?: number;
    rating?: number;
    reviews?: number;
    title?: string;
    keywords?: string;
    description?: string;
    root?: string;
    visible?: boolean;
    highlights?: Array<ProductHighlightDto>;
    overviews?: Array<ProductOverviewDto>;
    specifications?: Array<ProductSpecificationDto>;
    documents?: Array<ProductDocumentDto>;
    images?: Array<ProductImageDto>;
    distributors?: Array<ProductDistributorDto>;
    ratings?: Array<ProductRatingDto>;
    _new?: boolean;
}

